import { FC } from "react";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import { StateType } from "../../../backend/store";
import { useTranslation } from "../../../hooks/useTranslation";

export const OfflineBanner: FC = () => {
  const { p } = useTranslation("offline");
  const { isOnline, pendingCount, failedCount } = useSelector(
    (state: StateType) => state.offlineStore
  );

  // Nothing to say: online, nothing queued, nothing stuck.
  if (isOnline && pendingCount === 0 && failedCount === 0) return null;

  const isProblem = !isOnline || failedCount > 0;

  return (
    <Box
      role="status"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        // Logical properties only — this banner renders in RTL too.
        paddingBlock: 1,
        paddingInline: 2,
        backgroundColor: isProblem ? "warning.light" : "info.light",
        color: "text.primary",
      }}
    >
      {isOnline ? <SyncProblemIcon fontSize="small" /> : <CloudOffIcon fontSize="small" />}
      <Typography variant="body2">
        {!isOnline
          ? p("offline_banner")
          : failedCount > 0
          ? p("failed_banner", { count: failedCount })
          : p("syncing_banner", { count: pendingCount })}
      </Typography>
      {pendingCount > 0 && (
        <Typography variant="body2" sx={{ marginInlineStart: "auto", fontWeight: 600 }}>
          {pendingCount}
        </Typography>
      )}
    </Box>
  );
};
